import { CSSProperties } from 'react';

import { AppColors } from '../../theme';

type notificationMessageStyles = {
  notificationMessage: CSSProperties;
  notificationMessage__container: CSSProperties;
  notificationMessage__header: CSSProperties;
  notificationMessage__icon: CSSProperties;
  notificationMessage__title: CSSProperties;
  notificationMessage__text: CSSProperties;
  notificationMessage__actions: CSSProperties;
  notificationMessage__primaryButton: CSSProperties;
  notificationMessage__secondaryButton: CSSProperties;
};

const styles: notificationMessageStyles = {
  notificationMessage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '95%',
    width: '100%'
  },
  notificationMessage__container: {
    backgroundColor: AppColors.VA.NEUTRALS.WHITE,
    borderRadius: '8px',
    padding: '32px',
    maxWidth: '416px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  notificationMessage__header: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
    marginBottom: '12px'
  },
  notificationMessage__icon: {
    color: AppColors.VA.ERROR._50_,
    transform: 'scale(1.5)',
    display: 'inline-block',
    flexShrink: '0'
  },
  notificationMessage__title: {
    fontSize: '16px',
    fontWeight: 600,
    color: AppColors.VA.NEUTRALS._90_,
    lineHeight: '24px',
    margin: 0
  },
  notificationMessage__text: {
    fontSize: '14px',
    color: AppColors.VA.NEUTRALS._90_,
    fontWeight: 400,
    lineHeight: '22px',
    paddingLeft: '31px',
    marginTop: '-4px'
  },
  notificationMessage__actions: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'center',
    width: '100%',
    marginTop: '16px'
  },
  notificationMessage__primaryButton: {
    backgroundColor: AppColors.VA.PRIMARY._50_,
    color: AppColors.VA.NEUTRALS.WHITE,
    borderRadius: '24px',
    fontWeight: 400,
    fontSize: '14px',
    height: '48px',
    lineHeight: '22px',
    width: '50%'
  },
  notificationMessage__secondaryButton: {
    borderColor: AppColors.VA.PRIMARY._50_,
    color: AppColors.VA.PRIMARY._50_,
    borderRadius: '24px',
    fontWeight: 400,
    fontSize: '14px',
    height: '48px',
    lineHeight: '22px',
    width: '50%'
  }
};

export default styles;
